import { setDefaultValue, setCurrentValue } from '../../../features/settingTabs/slice';

export const setDefaultTab = (tag, value) => async dispatch => await dispatch(setDefaultValue({ tag, value }));
export const setCurrentTab = (tag, value) => async dispatch => await dispatch(setCurrentValue({ tag, value }));